import { Component, Inject, OnInit } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";

@Component({
    selector: "app-whats-on-detail",
    templateUrl: "./whats-on-detail.component.html",
    styleUrls: ["./whats-on-detail.component.scss"],
    standalone: true,
})
export class WhatsOnDetailComponent implements OnInit {
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private GTMSegment: GTMSegmentService) {
    this.GTMSegment.GTMPopupInitialization("WhatsOnDetail");
  }

  ngOnInit() { }
}
